import { ILocalStorageRepository } from "Infrastructure/interfaces/ILocalStorageRepository";
import { LocalStorageRepository } from "./_LocalStorageRepository";
import { getGlobalAddLog } from "../appInsights/AppInsights";
import { PedidoPos, responseSyncPedidoPos } from "../../interfaces/PedidoMeep";
import { ILocalStorageSyncPendingsRepository } from "../../interfaces/ILocalStorageSyncPendingsRepository";

const KEY = "@meep/SyncPendings";

const addLog = getGlobalAddLog();
const localStorageRepository: ILocalStorageRepository =
  LocalStorageRepository();

export const LocalStorageSyncPendingsRepository =
  (): ILocalStorageSyncPendingsRepository => {
    //Sincronização de pedido pendente
    const saveStorageOrder = async (pedidosPOS: PedidoPos[]) => {
      addLog &&
        addLog("[LocalStorageSyncPendingsRepository]", {
          message: "Add sync pending",
          pedidosPOS,
        });
      console.log("pedidosPOS", pedidosPOS);
      const storagePedidosPOS: PedidoPos[] =
        (await localStorageRepository.get<PedidoPos[]>(KEY)) ?? [];
      localStorageRepository.post(KEY, [...storagePedidosPOS, ...pedidosPOS]);
    };

    const getStoragePendentOrder = async (): Promise<PedidoPos[]> => {
      const storagePedidosPOS: PedidoPos[] =
        (await localStorageRepository.get<PedidoPos[]>(KEY)) ?? [];
      addLog &&
        addLog("[LocalStorageSyncPendingsRepository]", {
          message: "Get sync pending",
          storagePedidosPOS,
        });
      return storagePedidosPOS;
    };

    const removeSendedOrderFromStorageQueueAsync = async (
      responseIds: responseSyncPedidoPos[]
    ) => {
      const storagePedidosPos = await localStorageRepository.get<PedidoPos[]>(
        KEY
      );
      const newPendentStoragePedidosPos: PedidoPos[] = [];
      storagePedidosPos?.map((storagePedido) => {
        if (
          responseIds.findIndex(
            (responseIds) =>
              responseIds.pedidoPOSId === storagePedido.pedidoPOSId
          ) === -1
        ) {
          newPendentStoragePedidosPos.push(storagePedido);
        }
      });
      await localStorageRepository.remove(KEY);
      await saveStorageOrder(newPendentStoragePedidosPos);
      addLog &&
        addLog("[LocalStorageSyncPendingsRepository]", {
          message: "Update sync pending",
          newPendentStoragePedidosPos,
          responseIds,
        });
    };

    return {
      saveStorageOrder,
      getStoragePendentOrder,
      removeSendedOrderFromStorageQueueAsync,
    };
  };
